import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TakeawayServices } from '../services';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-select',
  templateUrl: 'takeaway-order-select.html',
})
export class TakeawayOrderSelectPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals, ) {
  }

  ionViewDidLoad() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-select/takeaway-order-select.ts